import React from 'react';
import { inject } from '@vercel/analytics';

inject();
import ReactDOM from 'react-dom/client';
import ErrorBoundary from './ErrorBoundary';
import App from './App';
import DigestReview from './DigestReview';
import AdminPage from './AdminPage';
import BillingSuccess from './BillingSuccess';
import BillingCancel from './BillingCancel';

const path = window.location.pathname;
const digestMatch = path.match(/^\/digest\/([^/]+)/);
const isAdmin = path === '/admin' || path.startsWith('/admin/');
const isBillingSuccess = path === '/billing/success';
const isBillingCancel = path === '/billing/cancel';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    {isBillingSuccess
      ? <BillingSuccess />
      : isBillingCancel
        ? <BillingCancel />
        : isAdmin
          ? <AdminPage />
          : digestMatch
            ? <DigestReview token={digestMatch[1]} />
            : <App />
    }
  </ErrorBoundary>
);
